import { useEffect } from "react";

export interface SeoConfig {
  title: string;
  description?: string;
  keywords?: string;
}

function setMeta(name: string, content: string, attr: "name" | "property" = "name") {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export default function useSeo({ title, description, keywords }: SeoConfig) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
    }
    if (keywords) setMeta("keywords", keywords);
    if (title) setMeta("og:title", title, "property");
  }, [title, description, keywords]);
}